(function () {
    'use strict';

    angular
        .module('businessPlanExplorerModule')
        .controller('BusinessPlanController', Controller);

    Controller.$inject = ['$scope', '$state', 'searchV2Service', 'topBarService', 'initiativeUpdateStatusService', 'followUpService', 'pagerService', 'permissionService', 'businessPlanExplorerService'];

    function Controller($scope, $state, searchV2Service, topBarService, initiativeUpdateStatusService, followUpService, pagerService, permissionService, businessPlanExplorerService) {
        topBarService.setTitleAndIcon('Business Plan Explorer', 'fa fa-compass');

        $scope.$state = $state;
        $scope.ctrlCtxt = {
            isLoading: true,
            isReIndexing: false
        };

        $scope.planDeliverables = [];
        $scope.showDeliverablesByQuarter = false;
        $scope.tabSelected = 0;

        $scope.pager = pagerService.newPager({ numberOfItemsPerPage: 1 });
        $scope.pagerLabels = { page: 'Elements' };

        var planCorporateObjectivesByID = {};

        // Permissions to show Followups
        $scope.canReviewAssessment = permissionService.hasPermission('GRCInitiativeUpdateStatusManagement', 'PlanInitiative', 'ReviewAssessment');
        $scope.canReIndexBPlanExplorer = permissionService.hasPermission('AdminTasks', 'Indexing_Manage', 'BusinessPlanExplorer');

        searchV2Service
            .initializeSearch(['BusinessPlanning'], {
                n: 9999,
                withHighlighting: false,
                sf: ["31;PlanInitiativeGovernanceProcessShortName:FY20 Business Plan"],
                sourceType: "BusinessPlanning"
            })
            .then(function (searchCtxt) {
                $scope.ctrlCtxt.searchCtxt = searchCtxt;
            });

        $scope.$watch('ctrlCtxt.searchCtxt', function(newVal, oldVal) {
            if (newVal !== oldVal) {
                init(newVal.sources[0].results);
            }
        });

        $scope.searchByAxe = function(planAxe) {
            searchByField('PlanInitiativePlanElementPlanAxeTitleENFacet', planAxe.TitleEN);
        };

        $scope.searchByElement = function(planElement) {
            searchByField('PlanInitiativePlanElementTitleENFacet', planElement.TitleEN);
        };

        $scope.searchByInitiative = function(planInitiative) {
            searchByField('PlanInitiativeTitleENFacet', planInitiative.TitleEN);
        };

        $scope.getAxisImage = function (planAxis) {
            // Remove last numbers (slug, slug1, slug10, etc.) => returns slug
            var slug = _
                .chain(planAxis)
                .dropRightWhile(function (char) {
                    return !Number.isNaN(Number(char))
                })
                .join('')
                .value();

		    return '/assets/Images/businessPlanExplorer/axis-' + slug + '.png';
        };

        $scope.canSeeFollowUps = function(planDeliverable) {
            return planDeliverable.PlanInitiative.OwnerID === $scope.authenticatedUser.ItemPersonID
                || planDeliverable.PlanInitiative.OwnerDelegateID === $scope.authenticatedUser.ItemPersonID
                || planDeliverable.PlanInitiative.ExecutiveSponsorID === $scope.authenticatedUser.ItemPersonID
                || planDeliverable.PlanInitiative.SecondaryOwnerID === $scope.authenticatedUser.ItemPersonID;
        };

        var currentPlanDeliverableFollowUps;

        $scope.openFollowups = function(planDeliverable) {
            if (!$scope.canReviewAssessment && !$scope.canSeeFollowUps(planDeliverable)) {
                return;
            }

            currentPlanDeliverableFollowUps = planDeliverable;

            initiativeUpdateStatusService
                .getFollowUpsByPlanDeliverableID(planDeliverable.PlanInitiativeID, planDeliverable.PlanDeliverableID)
                .then(function (delivAssContainers) {
                    followUpService.openFollowUpsModal(planDeliverable.TitleEN, null, null, delivAssContainers, getDownloadAttachmentUrl);
                });
        };

        function getDownloadAttachmentUrl (attachmentId, assessment) {
            return initiativeUpdateStatusService
                .getDownloadAttachmentUrl(
                    $scope.authenticatedUser.ItemPersonID,
                    currentPlanDeliverableFollowUps.PlanInitiativeID,
                    currentPlanDeliverableFollowUps.PlanDeliverableID,
                    assessment.PlanDeliverableAssessmentID,
                    attachmentId);
        }

        function searchByField(field, value) {
            $scope.tabSelected++;

            var sfParams = setField($scope.ctrlCtxt.searchCtxt.sources[0], field, value);

            searchV2Service.search({ sf: sfParams }).then(function (searchCtxt) {
                $scope.ctrlCtxt.searchCtxt = searchCtxt;
            });
        }

        function setField(source, field, value) {
        	if (value.value) {
        		value = value.value;
        	}

        	if (!_.has(source.faceting.selectedFields, field)) {
        		source.faceting.selectedFields[field] = {};
        	}

	        var selectedField = source.faceting.selectedFields[field];
	        selectedField[value] = _.isUndefined(selectedField[value]) || !selectedField[value];

	        return _.reduce(source.faceting.selectedFields, function (sfArray, sValues, sField) {

		        _.reduce(sValues, function (sfArray, isChecked, sValue) {
			        if (!isChecked) {
				        return sfArray;
			        }

			        var sf = source.ItemTypeID + ';' + sField + ':';

			        sf = sf + sValue;
			        sfArray.push(sf);

			        return sfArray;
		        }, sfArray);

                return sfArray;
            }, []);
        }

        /**
         * Unflatten Solr objects to regular objects and init view lists.
         * @param results Solr objects
         */
        function init(results) {
            // reconstruct objects
            var data = [];

            var objKeys = [
                ['PlanInitiative', 'PlanElement', 'PlanAxe'],
                ['PlanInitiative', 'PlanElement', 'GovernanceProcess'],
                ['PlanInitiative', 'PlanElement'],
                ['PlanInitiative', 'PlanCorporateObjective'],
                ['PlanInitiative', 'ExecutiveSponsor'],
                ['PlanInitiative', 'OwnerDelegate'],
                ['PlanInitiative', 'Owner'],
                ['PlanInitiative', 'SecondaryDelegate'],
                ['PlanInitiative', 'CompletionStatus'],
                ['PlanInitiative'],
                ['CompletionStatus']
            ];

            objKeys.forEach(function(objKey) {
                objKey.key = objKey.join('');
                objKey.path = objKey.join('.');
            });

            results.forEach(function(d) {
                var obj = {};
                data.push(obj);

                for (var k in d) {
                    if (d.hasOwnProperty(k)) {
                        var found = objKeys.some(function(objKey) {
                            if (_.startsWith(k, objKey.key)) {
                                if (objKey.key + 'ID' === k) {
                                    if (d[k] !== 0) {
                                        _.set(obj, objKey.path + '.' + objKey[objKey.length -1] + 'ID', d[k]);
                                        _.set(obj, objKey.path + 'ID', d[k]);
                                    }
                                } else {
                                    _.set(obj, objKey.path + '.' + k.replace(objKey.key, ''), d[k]);
                                }

                                return true;
                            }
                        });

                        if (!found) {
                            obj[k] = d[k];
                        }
                    }
                }
            });

            $scope.showDeliverablesByQuarter = false;

            initCorporateObjectives(data);
            initSummary(data);
            initPlanInitiatives(data);
            initPlanDeliverables(data);

            $scope.ctrlCtxt.isLoading = false;
        }

        function initCorporateObjectives(planDeliverables) {
            _.each(planDeliverables, function (planDeliverable) {
                var corpObjective = planDeliverable.PlanInitiative.PlanCorporateObjective;

                if (!corpObjective) return;

                _.each(corpObjective.PlanCorporateObjectiveID, function (corpObjID, idx) {
                    if (planCorporateObjectivesByID.hasOwnProperty(corpObjID)) return;

                    planCorporateObjectivesByID[corpObjID] = _.assign(
                        {},
                        corpObjective,
                        {
                            PlanCorporateObjectiveID: corpObjective.PlanCorporateObjectiveID[idx],
                            ObjectiveCode: corpObjective.ObjectiveCode[idx],
                            ObjectiveCodeTitleEN: corpObjective.ObjectiveCodeTitleEN[idx],
                            TitleEN: corpObjective.TitleEN[idx],
                        }
                    );
                });
            });
        }

        function initSummary(planDeliverables) {
            var indexElement = 1;
            var planElementsChain = _.chain(planDeliverables).uniqBy('PlanInitiative.PlanElement.PlanElementID');
            var planInitiativesChain = _.chain(planDeliverables).uniqBy('PlanInitiativeID');

            $scope.planAxes = _.uniqBy(planDeliverables, 'PlanInitiative.PlanElement.PlanAxeID').map(function (deliv) {
                var planAxe = deliv.PlanInitiative.PlanElement.PlanAxe;

                planAxe.PlanElements = planElementsChain
                    .filter({PlanInitiative: {PlanElement: {PlanAxeID: planAxe.PlanAxeID}}})
                    .map('PlanInitiative.PlanElement')
                    .value();

                planAxe.PlanElements.forEach(function (planElement) {
                    planElement.index = indexElement++;

                    planElement.PlanCorporateObjectives = planElementsChain
                        .find({PlanInitiative: {PlanElementID: planElement.PlanElementID}})
                        .get('PlanInitiative.PlanCorporateObjectiveID')
                        .map(function(corpObjectiveID){
                            return planCorporateObjectivesByID[corpObjectiveID]
                        })
                        .value();

                    planElement.PlanInitiatives = planInitiativesChain
                        .filter({PlanInitiative: {PlanElementID: planElement.PlanElementID}})
                        .map('PlanInitiative')
                        .value();

                    planElement.PlanCorporateMetricTitles = _.uniq(planElement.PlanCorporateMetricTitleEN);
                });

                return planAxe;
            });
        }

        function initPlanInitiatives(planDeliverables) {
            var deliverablesChain = _.chain(planDeliverables).filter('PlanDeliverableID').reject({ItemTypeID: 0});
            var deliverablesByInitiative = deliverablesChain.groupBy('PlanInitiativeID').value();

            $scope.showDeliverablesByQuarter = !!deliverablesChain.value().length;
            $scope.planInitiatives = _.chain(planDeliverables).uniqBy('PlanInitiativeID').map('PlanInitiative').value();

            $scope.planInitiatives.forEach(function(initiative) {
                initiative.PlanDeliverables = deliverablesByInitiative[initiative.PlanInitiativeID];
                initiative.PlanDeliverablesByQuarter = _.groupBy(initiative.PlanDeliverables, function(planDeliverable) {
                    return getDelivTargetYearQuarter(null, planDeliverable);
                });
            });

            $scope.planInitiativesByElement = _.chain($scope.planInitiatives).groupBy('PlanElementID').values().value();
            $scope.pager.updatePagerFromItems($scope.planInitiativesByElement);
        }

        function initPlanDeliverables(planDeliverables) {
            $scope.planDeliverables = planDeliverables;
        }

        /**
         * Get target fiscal year & quarter.
         * @param da DeliverableAssessment
         * @param d Deliverable
         * @returns {*}
         */
        function getDelivTargetYearQuarter(da, d) {
            d = d || da.PlanDeliverable;

            return _.get(da, 'ReviewTargetFiscalYearAndQuarter') || d.TargetFiscalYearAndQuarter;
        }

        $scope.reIndexBusinessPlanExplorer = function () {
            $scope.ctrlCtxt.isReIndexing = true;

            // Reindex Business plan explorer
            businessPlanExplorerService.reIndex()
            .finally(function () {
                window.location.reload();
                $scope.ctrlCtxt.isReIndexing = false;
            });
        };
    }
})();
